module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<fieldset class="gererbadgeages-detail cw-fieldset">\r\n  <div class="form-row">\r\n      <span class="collaborateur cw-titreLight"></span>\r\n  </div>\r\n  <div class="form-row">\r\n      <span class="periode cw-texteImportant"></span>\r\n  </div>\r\n  <div class="form-row">\r\n      <span class="table_badgeages"></span>\r\n  </div>\r\n</fieldset>';
}
return __p;
};
